import {
  DragDropDraggableItem,
  DRAGGING_KEEP_IN_PLACE_STYLE,
} from '../../../DragDrop'
import { RecipientTag } from '../RecipientTag'

import { getDraggableId } from './DraggableWrapper.utils'

function DraggableWrapper({
  Tag = RecipientTag,
  className,
  draggableItemClassName,
  droppableIndex,
  isDragDisabled,
  isOpen,
  item,
  sourceFieldId,
  ...restProps
}) {
  const draggableId = getDraggableId(droppableIndex, item)

  return (
    <DragDropDraggableItem
      keepInPlace
      className={draggableItemClassName}
      draggableProps={{
        data: {
          isOpen,
          item,
          sourceFieldId,
        },
        disabled: isDragDisabled,
      }}
      draggingStyle={DRAGGING_KEEP_IN_PLACE_STYLE}
      id={draggableId}
    >
      <div className={className}>
        <Tag
          {...restProps}
          disabled={isDragDisabled}
          isOpen={isOpen}
          item={item}
        />
      </div>
    </DragDropDraggableItem>
  )
}

export default DraggableWrapper
